import React, { memo, useContext } from "react";
import { type ContentItem } from "../../types";
import { BreakpointContext } from "../../../Application/components/context/BreakpointContext";
import styles from "./ContentItem.module.scss";
import { EntityType } from "../../../common/types";
import { ProgressAssetCard } from "features/Application/components/Card/Assets/ProgressAssetCard/ProgressAssetCard";
import { Routes } from "features/common/routes";

interface Props {
  item: ContentItem;
  interactive?: boolean;
}

export const getRouteForEntity = (item: EntityType) => {
  switch (item) {
    case EntityType.Assessment:
      return Routes.Discover.assessment;
    case EntityType.Survey:
      return Routes.Discover.survey;
    case EntityType.Event:
      return Routes.Discover.event;
    case EntityType.Flow:
      return Routes.Discover.flows;
    case EntityType.Pdf:
      return Routes.Discover.pdf;
    case EntityType.EmbeddedVideo:
      return Routes.Discover.embeddedVideo;
    default:
      return Routes.Discover.asset;
  }
};

export const NavigatableContentItem: React.FC<Props> = ({ item, interactive }) => {
  const { isMobileScreen } = useContext(BreakpointContext);

  const baseItemDetailsPath = getRouteForEntity(item.entityType);

  return (
    <div className={styles.cardWrapper}>
      <ProgressAssetCard
        orientation={isMobileScreen ? "vertical" : "horizontal"}
        item={item}
        to={item.id ? `${baseItemDetailsPath}/${item.id}` : null}
        interactive={interactive}
      />
    </div>
  );
};

export default memo(NavigatableContentItem);
